class MikolitoArchipelago extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('[data-mik-modal-overlay]');
    this.modal = this.querySelector('.mik-archi__modal');
    this.closeBtn = this.querySelector('[data-mik-modal-close]');
    this.header = this.querySelector('[data-mik-modal-header]');
    this.headItems = Array.from(this.querySelectorAll('.mik-archi__modal-headitem'));
    this.panels = Array.from(this.querySelectorAll('.mik-archi__modal-panel'));
    this.lastFocused = null;

    this.querySelectorAll('[data-mik-island]').forEach((tile) => {
      tile.addEventListener('click', (event) => {
        // Let modified / non-primary clicks follow the real href (open series page).
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(tile);
      });
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', (event) => {
        if (event.target === this.overlay) this.close();
      });
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }
    document.addEventListener('keydown', (event) => {
      if (!this.overlay?.classList.contains('is-open')) return;
      if (event.key === 'Escape') this.close();
      if (event.key === 'Tab') this.trapFocus(event);
    });
  }

  open(tile) {
    const index = tile.dataset.mikPanel;

    this.headItems.forEach((item) => {
      item.hidden = item.dataset.mikHead !== index;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.mikPanel !== index;
    });

    const activeHead = this.headItems.find((item) => item.dataset.mikHead === index);
    if (this.header) this.header.style.background = (activeHead && activeHead.dataset.mikAccent) || '';

    this.lastFocused = document.activeElement;
    this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.closeBtn?.focus();
  }

  close() {
    this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    this.lastFocused?.focus();
  }

  trapFocus(event) {
    const selector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const focusable = Array.from(this.modal.querySelectorAll(selector)).filter(
      (el) => el.offsetParent !== null
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

customElements.define('mikolito-archipelago', MikolitoArchipelago);
